import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import DialogContent from "@mui/material/DialogContent";
import { useDocumentStore } from "../../../Store";
import { useEffect, useState } from "react";

export default function ShowDocs({ data }) {
  const ITEMS = useDocumentStore((s) => s.documents);
  const [doc, setDoc] = useState([]);
  /*const doc = [
    { uri: "https://api.energoproapp.com" + data }, // Local File
  ];*/

  const findPathById = (arrayITEM, targetId) => {
    for (const item of arrayITEM) {
      if (item.id === targetId && !item.children) {
        return item.path;
      }

      if (item.children && !item.path) {
        const childPath = findPathById(item.children, targetId);
        if (childPath) return childPath;
      }
    }
    return null;
  };
  useEffect(() => {
    let path = findPathById(ITEMS, data);
    if (path)
      setDoc([
        { uri: "https://api.energoproapp.com" + path }, // Local File
      ]);
  }, [data]);

  return (
    doc[0]?.uri && (
      <DialogContent dividers>
        <DocViewer
          documents={doc}
          config={{
            header: {
              disableHeader: true,
            },
          }}
          pluginRenderers={DocViewerRenderers}
          style={{ width: "100%", minWidth: 550, height: 680 }}
        />
      </DialogContent>
    )
  );
}
